module.exports = __webpack_public_path__ + "img/border-bottom-right.bc40bb50.svg";